/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![HeartOutlineIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACIElEQVR4nO1UO2sVURDeoMYXarQWFB+looVaydUisHh3HvfCycxuhG30tqJYiZX6D1IF/4GKrSDpJGKjnQSx8YGiIpoUEiuvzN5zNjHZ+8q1sHDgwO7st9/MN2dmoui/DWPOuX1AegdJFpD1J7J8Q5KnyHItSZIdATc5eXFnQnIdWJ4BydcCS7IAJLfr9WxvJTlRdgJYPiBru+oAyXvm9DSingHWd71wAHp8feaBnPQ5kZyN43irZQMsZJl6gh/+tE0ZUQqGMaz9AywvQpA/lBRl8eTOufGK0m0ClrurMp01XwVuPARB1lvlB1/ztmXR44rGkHTGjj13AyWc1goVrC9XB1g2Zy3Pt/UIEHniruRmzrntvoTLpRNIF815oZkdiEY0IjnYUSDfVwKwzhdRURujBgCWplfwpHQi6lXvfDxqAGSd61yyXCmdcTy9G1mWkPUXkZzbMDlOne+0qS4i4q61kW96FW+cc3uGJSfKJ5D1rZ+DG+sAtVptc2ctFD08Z8MzKLn1P5I88u05XzUjhdWb2SFk+eSH7l6r1drSj9wwwHLfZ/7RuqiP1OxYseS8EqJ8ohvW1kG41E7d9eRAkoulRvolTKQpW4sBcEfCBgCSz0lj6tRA5GV2zfQosr72LbcErHlJzpoGlUD6ilkORxsx6yZgebiy5ORBqHd4txaPRrQxZL0c1kmoN1F6qd9eGsoajen91ll27PmvEf/z9huH+Cz+J7d04QAAAABJRU5ErkJggg==)
 */
export const HeartOutlineIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M12 8.07 10.6 6.7A5 5 0 0 0 6.75 5 3.75 3.75 0 0 0 3 8.75c0 2.32 1.59 4.76 3.87 6.96A31.87 31.87 0 0 0 12 19.67c1.2-.74 3.26-2.14 5.13-3.96 2.28-2.2 3.87-4.64 3.87-6.96A3.75 3.75 0 0 0 17.25 5a5 5 0 0 0-3.85 1.69L12 8.07Zm0-2.8A6.98 6.98 0 0 0 6.75 3 5.75 5.75 0 0 0 1 8.75c0 6.34 8.42 11.73 10.53 12.98.29.17.65.17.94 0C14.57 20.48 23 15.09 23 8.75A5.75 5.75 0 0 0 17.25 3c-2.34 0-3.88.9-5.25 2.26Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
